// Lettura di un file scelto dall'utente come data-URI base64: il formato con
// cui i backend ricevono allegati e foto (vedi BookingAttachmentUploadDto).
export const MAX_ALLEGATO_MB = 20;

export const leggiComeDataUri = (file) => new Promise((resolve, reject) => {
  const lettore = new FileReader();
  lettore.onload = () => resolve(lettore.result);
  lettore.onerror = () => reject(lettore.error);
  lettore.readAsDataURL(file);
});

export const troppoGrande = (file) => file.size > MAX_ALLEGATO_MB * 1024 * 1024;
